const baseUrl = "https://server-transport.vercel.app";

export default baseUrl;
